// HUB-8360: Manual backfill for missing shipment transaction logs (e.g. BagOutScan)
import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import { BasicSelect } from 'vue-search-select';

export default {
  name: 'MissingShipmentLogReconcile',

  components: {
    VueElementLoading,
    Multiselect,
    BasicSelect
  },

  data() {
    return {
      maxShippingIdLimit: 50,
      hublist: [],
      hubnameArr: [],
      hubid: '',
      hubname: '',
      hubnameerror: '',
      hubloader: '',
      hubitem: {
        value: '',
        text: ''
      },
      shippingid: '',
      shipmentLimit: false,
      shipmentLimitMsg: '',
      createdby: '',
      isLoading: false,
      eventList: [
        {
          value: 'BagOutScan',
          text: 'Bag Out Scan'
        }
      ],
      event: '',
      eventItem: {
        value: 'BagOutScan',
        text: 'Bag Out Scan'
      },
      showResults: false,
      reconcileResults: []
    };
  },

  mounted() {
    const userdetailEncrypt = window.localStorage.getItem('userdetail');
    const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    const userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email;
    this.getHubList();
    this.selectEvent(this.eventItem);
  },

  methods: {
    getHubList() {
      this.hubloader = 'Loading Hub...';
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
        data: {},
        headers: {
          authorization: 'authkey xB84JJ89Hd25'
        }
      })
        .then((result) => {
          this.hubloader = '';
          if (result.data.ResultCode !== 100 && !result.data.ResponseData) {
            this.$alertify.error(result.data.ReturnMessage || 'Failed to load hub list');
            return;
          }
          const hubDetails = result.data.ResponseData || [];
          this.hublist = [];
          for (let i = 0; i < hubDetails.length; i++) {
            this.hublist.push({
              value: hubDetails[i].HubID,
              text: hubDetails[i].HubName + ' (' + hubDetails[i].HubID + ')'
            });
          }
        }, (error) => {
          this.hubloader = '';
          console.error(error);
          this.$alertify.error('Failed to load hub list');
        });
    },

    setSelectedHub(hubitem) {
      this.hubid = hubitem.value;
      this.hubname = hubitem.text.split('(')[0].trim();
      this.hubitem = hubitem;
      if (!this.hubname) {
        this.hubnameerror = 'Select Hub Name';
      } else {
        this.hubnameerror = '';
      }
    },

    selectEvent(eventItem) {
      this.eventItem = eventItem;
      this.event = eventItem.text;
    },

    parseShippingIds(raw) {
      if (!raw) {
        return [];
      }
      let normalized = raw;
      if (typeof normalized !== 'string') {
        normalized = normalized.join(',');
      }
      if (/\r?\n|\r/g.test(normalized)) {
        normalized = normalized.replace(/\r?\n|\r/g, ',');
      }
      if (/\s/g.test(normalized) || normalized.indexOf(',') > -1) {
        normalized = normalized.replace(/\n|"|'| |,\s*$/g, '').split(',').filter((item) => item);
      } else if (normalized) {
        normalized = [normalized];
      } else {
        normalized = [];
      }
      const seen = new Set();
      const unique = [];
      normalized.forEach((id) => {
        const trimmed = String(id).trim();
        if (trimmed && !seen.has(trimmed)) {
          seen.add(trimmed);
          unique.push(trimmed);
        }
      });
      return unique;
    },

    validateBeforeSubmit() {
      this.shipmentLimit = false;
      this.shipmentLimitMsg = '';

      if (!this.hubid) {
        this.hubnameerror = 'Select Hub Name';
        return false;
      }

      const ids = this.parseShippingIds(this.shippingid);
      if (!ids.length) {
        this.shipmentLimit = true;
        this.shipmentLimitMsg = 'Enter at least one shipping ID';
        return false;
      }
      if (ids.length > this.maxShippingIdLimit) {
        this.shipmentLimit = true;
        this.shipmentLimitMsg = 'Please enter shipment quantity up to ' + this.maxShippingIdLimit;
        return false;
      }

      if (!this.eventItem || !this.eventItem.value) {
        return false;
      }

      this.parsedShippingIds = ids;
      return true;
    },

    reconcileMissingLogs() {
      const payload = {
        hubId: this.hubid,
        shippingIds: this.parsedShippingIds,
        event: this.eventItem.value,
        createdBy: this.createdby
      };

      this.isLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'reconcileMissingShipmentLogs',
        data: payload,
        headers: {
          authorization: 'authkey xB84JJ89Hd25'
        }
      })
        .then((result) => {
          this.isLoading = false;
          if (result.data.ResultCode === 100) {
            this.$alertify.success(result.data.ReturnMessage || 'Reconciliation completed');
            this.applyApiResults(result.data.ResponseData);
          } else {
            this.$alertify.error(result.data.ReturnMessage || 'Reconciliation failed');
            if (result.data.ResponseData && result.data.ResponseData.results) {
              this.applyApiResults(result.data.ResponseData);
            }
          }
        }, (error) => {
          this.isLoading = false;
          if (error.response && error.response.status === 404) {
            this.$alertify.error('Reconciliation API is not deployed yet. Please try again after backend release.');
            return;
          }
          const message = error.response && error.response.data && error.response.data.ReturnMessage
            ? error.response.data.ReturnMessage
            : (error.message || 'Request failed');
          this.$alertify.error(message);
        });
    },

    applyApiResults(responseData) {
      if (!responseData || !responseData.results || !responseData.results.length) {
        this.showResults = false;
        this.reconcileResults = [];
        return;
      }
      this.reconcileResults = responseData.results.map((row) => ({
        shippingId: row.shippingId,
        resultCode: row.resultCode,
        returnMessage: row.returnMessage
      }));
      this.showResults = true;
    },

    resetForm() {
      this.hubid = '';
      this.hubname = '';
      this.hubnameArr = [];
      this.hubnameerror = '';
      this.shippingid = '';
      this.shipmentLimit = false;
      this.shipmentLimitMsg = '';
      this.showResults = false;
      this.reconcileResults = [];
      this.eventItem = {
        value: 'BagOutScan',
        text: 'Bag Out Scan'
      };
      this.event = this.eventItem.text;
      this.$validator.reset();
    },

    onSubmit() {
      this.$validator.validateAll().then((valid) => {
        if (!valid) {
          return false;
        }
        if (!this.validateBeforeSubmit()) {
          return false;
        }
        this.reconcileMissingLogs();
        return true;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/MissingShipmentLogReconcile/MissingShipmentLogReconcile.js